/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';

// UITK components
import { DatePicker, Typeahead } from 'src/components/common/modules/form';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

//helpers
import {
  formatDateWithLang,
  getDateFormatWithLang,
  getLocalizationData,
  getWizardUrlOverrideURL,
  getWizOverrideDateParaName,
  renderInvalidTypeheadStyles,
  getWizardDefaults,
  WizardDefaultProps,
  wizardDate,
  getWizardsOverrides,
  getValidReturnDate,
} from '../../helpers';
import { checkValue } from 'src/components/common/helper';
import { UitkButtonSize } from 'uitk-react-button';
import { getSearchToolsQueryParams, QueryParamsStrategies } from '@shared-utils/search-tools-query-params-mapper';
import { linkTabOpenner } from '../../SearchWizard';
import { useLocalization } from '@shared-ui/localization-context';
import { useStores } from 'src/utils/useStore';
import { sendSearchWizardSearchGTMEvent } from 'src/components/common/utils/gtmHelperFunctions';

export const LogdingUitk: React.FC<any> = ({ localizationData, device, data, mccidData, isAdvanced, setSearchFilters }) => {
  const { context } = useStores();

  const siteBrand = context?.site?.brand; 
  const urlParam = {
    adults: '1',
    cabinClass: 'e',
    destination: '',
    endDate: '',
    origin: '',
    startDate: '',
  };
  const { formatDateString } = useLocalization();

  const today = new Date();
  const dayAfterTwoWeeks = new Date();
  const nextDayAfterDayAfterTwoWeeks = new Date();
  dayAfterTwoWeeks.setDate(today.getDate() + 14);
  nextDayAfterDayAfterTwoWeeks.setDate(today.getDate() + 15);

  const searchedDateFormat = getDateFormatWithLang(context?.locale, 'yyyy-MM-dd');

  // Check the default data is coming from the searchOverride if so
  // Get the code
  const wizardDefault: WizardDefaultProps = {
    data,
    lob: 'Hotel',
    overrideController: 'returnDefault',
  };
  const wizardReturnDefaultPreset: WizardDefaultProps = {
    data,
    lob: 'Hotel',
    overrideController: 'returnPreset',
  };
  const wizardOverrideDefault = getWizardDefaults(wizardDefault);
  const wizardHotelDestinationPresetDefault = getWizardDefaults(wizardReturnDefaultPreset);  
  let returnDefault = '';
  let isWizardOverrideUrlIgnore = true;

  /**
   * 1) if wizard override in hotel tab - check returnDefault is available
   * 2) else if wizard override in hotel tab - check returnDefaultPreset is available
   * 3) else common returnDefault
   */
  if (checkValue(wizardOverrideDefault, true)) {
    const getReturn = wizardOverrideDefault?.find((w) => w.key === 'returnDefault');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;
      isWizardOverrideUrlIgnore = false;
    }    
  } else if(checkValue(wizardHotelDestinationPresetDefault, true)) {
    const getReturn = wizardHotelDestinationPresetDefault?.find((w) => w.key === 'returnPreset');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;      
    }
  } else {
    const wizardOverrides = get(data, 'wizardUrlOverride', []);   
    // Check the wizard override has value
    // if so set isWizardOverrideUrlIgnore = false
    if(checkValue(wizardOverrides,true)){
      const wizardOverrideHotel = wizardOverrides?.filter((cat) => cat?.wizardTab === 'Hotel');        
      if(checkValue(wizardOverrideHotel, true) && wizardOverrideHotel[0]?.searchUrlOverride !== ''){          
          isWizardOverrideUrlIgnore = false;         
      }
    }   

    returnDefault = get(data, 'returnDefault', '');    
  }

  // Get Wizard Overrides Date
  const wizardOverrides = getWizardsOverrides(data, 'Hotel');
  let wizardOverridesDepartureDate = '';
  let wizardOverridesReturnDate = '';
  if (checkValue(wizardOverrides, true)) {
    wizardOverridesDepartureDate = wizardOverrides?.[0]?.dateFrom;
    wizardOverridesReturnDate = wizardOverrides?.[0]?.dateTo;
  }

  const departureDate = wizardDate(
    get(data, 'departureDate', ''),
    get(data, 'departureDateFixed', ''),
    wizardOverridesDepartureDate,
    dayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    ''
  );
  const returnDatewizardDate = wizardDate(
    get(data, 'returnDate', ''),
    get(data, 'returnDateFixed', ''),
    wizardOverridesReturnDate,
    nextDayAfterDayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    get(data, 'lengthOfStay', '')
  );
  
  const returnDate = getValidReturnDate(departureDate, returnDatewizardDate);
  
  const initFormState = {
    goingTo: { value: returnDefault, error: '', typeHeadId: 'textDestiWizard' },
    departureDate: {
      value: departureDate,
      error: '',
    },
    returnDate: {
      value: returnDate,
      error: '',
    },
  };

  const [formState, setFormState] = useState(initFormState);

  const isTravelerError = false;

  //onChangeHandler
  const onChangeHandler = (state, value) => {
    setFormState((prev) => ({
      ...prev,
      [state]: {
        ...prev?.[state],
        value,
        error: '',
      },
    }));
  };

  //handle validations
  const handleValidations = () => {
    let isValidate = true;
    let goingToError = '';

    if (formState?.goingTo?.value === '') {
      isValidate = false;
      goingToError = getLocalizationData(
        localizationData,
        'select_destination',
        'Please select a destination',
        device
      );
    }

    setFormState((prev) => ({
      ...prev,
      goingTo: { ...prev?.goingTo, error: goingToError },
    }));

    return isValidate;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isTravelerError) {
      if (handleValidations()) {
        const { elements } = event.currentTarget;
        const tempobj = { ...urlParam };
        const inputs = Array.from(elements) as HTMLInputElement[];

        const queryParams = getSearchToolsQueryParams(QueryParamsStrategies.LODGING, inputs);
       
        let searchURL = '';
        const domain = window.location.origin;

        inputs.forEach((input) => {
          const inputVal: string = checkValue(input.value) ? input.value : '';

          if (input.name !== '') {
            if (input.name === 'EGDSSearchFormTravelersField-Adult-Room1') {
              tempobj.adults = inputVal;
            }
            if (input.name === 'EGDSSearchFormLocationField-Location-origin_select') {
              tempobj.origin = inputVal;
            }
            if (input.name === 'EGDSSearchFormLocationField-Location-destination_form_field') {
              tempobj.destination = inputVal;
            }
            if (input.name === 'cabin_class_input') {
              tempobj.cabinClass = inputVal;
            }
            if (input.name === 'EGDSDateRangePicker-EndDate-date_form_field') {
              tempobj.endDate = inputVal;
            }
            if (input.name === 'EGDSDateRangePicker-StartDate-date_form_field') {
              tempobj.startDate = inputVal;
            }
            return { ...tempobj };
          }
        });


        const startDateFormatHotels = formatDateWithLang(context?.locale, tempobj.startDate, 'yyyy-MM-dd');
        const endDateFormatHotels = formatDateWithLang(context?.locale, tempobj.endDate, 'yyyy-MM-dd');

        // Hotel Search Removed Due To Expedia and Hotel use same search
        // if (siteBrand === 'hotels') {
        //   searchURL =
        //     getWizardUrlOverrideURL('Hotel', domain + '/Hotel-Search', data?.wizardUrlOverride) +
        //     'destination=' +
        //     tempobj.destination +
        //     '&' +
        //     getWizOverrideDateParaName('Hotel', 'dateFrom', 'DATEFROM', 'd1', data?.wizardUrlOverride) +
        //     '=' +
        //     formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
        //     '&' +
        //     getWizOverrideDateParaName('Hotel', 'dateTo', 'DATETO', 'd2', data?.wizardUrlOverride) +
        //     '=' +
        //     formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
        //     '&' +
        //     getWizOverrideDateParaName('Hotel', 'dateFrom', 'DATEFROM', 'startDate', data?.wizardUrlOverride) +
        //     '=' +
        //     formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
        //     '&' +
        //     getWizOverrideDateParaName('Hotel', 'dateTo', 'DATETO', 'endDate', data?.wizardUrlOverride) +
        //     '=' +
        //     formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
        //     '&adults=' +
        //     tempobj.adults+
        //     '&rooms=1';

        // }
        
        if(siteBrand === 'vrbo'){          
          const inputSearchArr = queryParams?.split('&');
          let searchDataForVrbo = '';         
          inputSearchArr.forEach((uInput:string) => {           
            if(uInput.indexOf('destination=') > -1 ){
              searchDataForVrbo += uInput.replace('?destination=','keywords:')+'/';
            }
            if(uInput.indexOf('startDate=') > -1 ){
              searchDataForVrbo += uInput.replace('startDate=','arrival:')+'/';
            }
            if(uInput.indexOf('endDate=') > -1 ){
              searchDataForVrbo += uInput.replace('endDate=','departure:')+'/';
            }
          });
                    
          searchDataForVrbo += '?adultsCount=2&petIncluded=false&filterByTotalPrice=true';
                 
          const vrboMainUrl = getWizardUrlOverrideURL('Hotel', domain + '/search/', data?.wizardUrlOverride).replace('?','').replace('&','')+searchDataForVrbo;
          
          searchURL = vrboMainUrl;
        }
        else {
          if (checkValue(data?.wizardUrlOverride, true) && !isWizardOverrideUrlIgnore) {
            const objURL = data?.wizardUrlOverride.filter((item) => item.wizardTab === 'Hotel');            
            if (checkValue(objURL?.[0])) {
              const tempURL = 'go/hotel/search/Destination';
              const hotelOverrideURL = getWizardUrlOverrideURL('Hotel', '/Hotel-Search?', data?.wizardUrlOverride);

              let newHotelOverrideURL = tempURL;

               // Check days in future available
              if(!hotelOverrideURL.toLowerCase().includes('daysinfuture')){
                 newHotelOverrideURL =
                  tempURL +
                  '/' +
                  formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
                  '/' +
                  formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' });
              }

              searchURL = hotelOverrideURL.replace(tempURL, newHotelOverrideURL);

              // Check adults available
              if(!hotelOverrideURL.toLowerCase().includes('numadult') && !hotelOverrideURL.toLowerCase().includes('adults')){
                searchURL = searchURL + '&adults=' + tempobj.adults;
              }              
              
            } else {
              searchURL = `/Hotel-Search${queryParams}`;
            }
          } else {
            searchURL = `/Hotel-Search${queryParams}`;
          }
        }       
        const searchParameters = startDateFormatHotels?.date + ' - ' + endDateFormatHotels?.date + '|' + tempobj.destination;
        
        if (checkValue(isAdvanced) && isAdvanced === true){
          setSearchFilters({...tempobj, type: 'hotel', searchURL, mccid: mccidData});
          return;
        }

        sendSearchWizardSearchGTMEvent('wizard_search', 'Hotels', searchParameters , searchURL);
              
        linkTabOpenner(searchURL, mccidData);
      }
    }
  };

  const updateTypeahead = (selectedValue) => {
    onChangeHandler('goingTo', selectedValue);
  };
  const updateDates = (startDate, endDate) => {
    console.log(startDate, endDate);
  };

  const primaryButtonProps: PrimaryButtonProps = {
    text: getLocalizationData(localizationData, 'search_button_copy', 'Search', device),
    tag: 'button',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Featured Content',
      eventLabel: `${getLocalizationData(localizationData, 'search_button_copy', 'Search', device)} - ${'cTALink'}`,
    },
    exClass: `btn mobile-btn`,
    target: '_blank',
    size: UitkButtonSize.LARGE,
  };
  useEffect(() => {
    const errors = Object.keys(formState)
      .map((key) => ({
        error: get(formState, `[${key}].error`, ''),
        typeheadId: get(formState, `[${key}].typeHeadId`, ''),
      }))
      .filter(({ typeheadId }) => typeheadId !== '' && typeheadId !== false && typeheadId !== undefined);

    renderInvalidTypeheadStyles(errors);
  }, [formState]);

  return (
    <>
      <div className="lodging-wrapper" data-testid="lodging-search-form">
        <form onSubmit={handleSubmit}>
          <UitkLayoutFlex space="six" alignItems="center" justifyContent="end">
          </UitkLayoutFlex>
          <div className="grid">
            <UitkLayoutGrid columns={{ small: 1 }} className="wizard-row-top-margin">
              <UitkLayoutGridItem>
                <UitkLayoutGrid columns={{ small: 1, medium: 2 }} space="three">
                  <UitkLayoutGridItem>
                    <Typeahead
                      controlid={formState?.goingTo?.typeHeadId}
                      label={getLocalizationData(
                        localizationData,
                        'location_label_copy',
                        'Find accommodation in',
                        device
                      )}
                      icon={'place'}
                      name={'EGDSSearchFormLocationField-Location-destination_form_field'}
                      controller={'typeahead'}
                      updateModel={updateTypeahead}
                      placeholder={getLocalizationData(
                        localizationData,
                        'location_placeholder_copy',
                        'City or Airport',
                        device
                      )}
                      value={formState?.goingTo?.value}
                      hasClearButton={false}
                      lob={GlobalNavigationLineOfBusiness.HOTEL}
                      error={formState?.goingTo?.error}
                      device={device}
                    />
                  </UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <DatePicker
                      updateDates={updateDates}
                      startDate={formState?.departureDate?.value}
                      endDate={formState?.returnDate?.value}
                      startPlaceHolder={getLocalizationData(
                        localizationData,
                        'check_in_label_copy',
                        'Check-in',
                        device
                      )}
                      endPlaceHolder={getLocalizationData(
                        localizationData,
                        'check_out_label_copy',
                        'Check-out',
                        device
                      )}
                      startDateState={'packageStartDate'}
                      endDateState={'packageEndDate'}
                      singleMode={false}
                      doubleMonths={true}
                      selectCopy={getLocalizationData(localizationData, 'date_picker_select', 'Select Date', device)}
                      startLabel={getLocalizationData(localizationData, 'check_in_label_copy', 'Check-in', device)}
                      endLabel={getLocalizationData(localizationData, 'check_out_label_copy', 'Check-out', device)}
                      singleDateSelect={true}
                      dateFormat={searchedDateFormat}
                    />
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <UitkLayoutGrid alignItems="center">
                  <UitkLayoutGridItem>
                    <div className="wizard-search-button-container">
                      <PrimaryButton {...primaryButtonProps} />
                    </div>
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </form>
      </div>
    </>
  );
};
